import { useEffect } from 'react'
import { Plus, Loader2 } from 'lucide-react'
import { Button } from '@/components/ui'
import { usePlaidLinkConnect, useFamily } from '@/hooks'

interface PlaidLinkButtonProps {
  /** Terracotta accent is reserved for connect CTAs — this is the connect CTA. */
  variant?: 'accent' | 'default' | 'secondary' | 'outline' | 'ghost'
  size?: 'sm' | 'default' | 'lg'
  className?: string
}

export function PlaidLinkButton({
  variant = 'accent',
  size = 'default',
  className,
}: PlaidLinkButtonProps) {
  const { selectedFamilyId } = useFamily()
  const { connect, openPlaidLink, isReady, isLoading, error } = usePlaidLinkConnect(selectedFamilyId)

  // Auto-open Plaid Link when ready
  useEffect(() => {
    if (isReady) {
      openPlaidLink()
    }
  }, [isReady, openPlaidLink])

  const handleClick = async () => {
    await connect()
  }

  return (
    <div>
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={handleClick}
        disabled={isLoading || !selectedFamilyId}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            Connecting…
          </>
        ) : (
          <>
            <Plus className="mr-2 h-4 w-4" />
            Connect a bank account
          </>
        )}
      </Button>
      {error && <p className="mt-2 text-sm text-error-600">{error}</p>}
    </div>
  )
}
